"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipTransactionValidation = void 0;
const MembershipActionCodeValidation_1 = require("./MembershipActionCodeValidation");
const MembershipValidationErrorValidation_1 = require("./MembershipValidationErrorValidation");
class MembershipTransactionValidation {
    static isValid(entity) {
        // Validate entity.id for existence and correct type.
        if (entity.id == undefined)
            return false;
        if (typeof entity.id !== "string")
            return false;
        // Validate entity.membership_presented_timestamp for existence and correct type.
        if (entity.membership_presented_timestamp == undefined)
            return false;
        if (!(entity.membership_presented_timestamp instanceof Date))
            return false;
        // If entity.membership_token exists, validate that it has the correct type.
        if (entity.membership_token != undefined) {
            if (typeof entity.membership_token !== "string")
                return false;
        }
        // If entity.is_valid exists, validate that it has the correct type.
        if (entity.is_valid != undefined) {
            if (typeof entity.is_valid !== "boolean")
                return false;
        }
        // If entity.membership_status_code exists, validate that it has the correct type.
        if (entity.membership_status_code != undefined) {
            if (typeof entity.membership_status_code !== "string")
                return false;
        }
        // If entity.port_id exists, validate that it has the correct type.
        if (entity.port_id != undefined) {
            if (typeof entity.port_id !== "number")
                return false;
        }
        // If entity.success exists, validate that it has the correct type.
        if (entity.success != undefined) {
            if (typeof entity.success !== "boolean")
                return false;
        }
        // If entity.valid_membership_expiration exists, validate that it has the correct type.
        if (entity.valid_membership_expiration != undefined) {
            if (!(entity.valid_membership_expiration instanceof Date))
                return false;
        }
        // If entity.validation_error exists, validate that it has the correct type.
        if (entity.validation_error != undefined) {
            if (!MembershipValidationErrorValidation_1.MembershipValidationErrorValidation.isValid(entity.validation_error))
                return false;
        }
        // If entity.membership_can_be_used_as_payment exists, validate that it has the correct type.
        if (entity.membership_can_be_used_as_payment != undefined) {
            if (typeof entity.membership_can_be_used_as_payment !== "boolean")
                return false;
        }
        // If entity.action_code exists, validate that it has the correct type.
        if (entity.action_code != undefined) {
            if (!MembershipActionCodeValidation_1.MembershipActionCodeValidation.isValid(entity.action_code))
                return false;
        }
        // If entity.action_id exists, validate that it has the correct type.
        if (entity.action_id != undefined) {
            if (typeof entity.action_id !== "number")
                return false;
        }
        // If entity.tier_code exists, validate that it has the correct type.
        if (entity.tier_code != undefined) {
            if (typeof entity.tier_code !== "string")
                return false;
        }
        // If entity.inform_proceed_confirmed exists, validate that it has the correct type.
        if (entity.inform_proceed_confirmed != undefined) {
            if (typeof entity.inform_proceed_confirmed !== "boolean")
                return false;
        }
        // If entity.initial_points exists, validate that it has the correct type.
        if (entity.initial_points != undefined) {
            if (typeof entity.initial_points !== "number")
                return false;
        }
        // If entity.session_earned_points exists, validate that it has the correct type.
        if (entity.session_earned_points != undefined) {
            if (typeof entity.session_earned_points !== "number")
                return false;
        }
        return true;
    }
}
exports.MembershipTransactionValidation = MembershipTransactionValidation;
